import { render, staticRenderFns } from "./PriceLogTable.vue?vue&type=template&id=02d17006&"
import script from "./PriceLogTable.vue?vue&type=script&lang=js&"
export * from "./PriceLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports